// extracted by mini-css-extract-plugin
export default {"content":"ConfigurationShareModal__content___tM9_6"};